import Link from 'next/link';
import { sourceCredit } from 'utils/newsroom';
import styles from 'styles/modules/newsAlert/Newsroom.module.scss';

// The expert who seeded a Raw from their own intel, linked to their profile.
const SourceCredit = ({ seededBy }) => (
    <Link href={`/${seededBy.slug}`}>
        <a className={styles.sourceCredit}>
            {`Source: ${sourceCredit(seededBy)}`}
        </a>
    </Link>
);

export default SourceCredit;
